<template>
  <el-button-group>
    <el-button type="primary" @click="sendEmergency(23)">{{ $t('button.openAll') }}</el-button>
    <el-button type="primary" @click="sendEmergency(24)">{{ $t('button.normal') }}</el-button>
    <el-button type="primary" @click="sendEmergency(25)">{{ $t('button.disableAll') }}</el-button>
  </el-button-group>
</template>

<script>
import { post } from 'providers/http'

export default {
  name: 'emergency-function',
  methods: {
    sendEmergency (state) {
      post('api/v1/emergency', {state})
    }
  }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// EmergencyFunctions.vue?79032914